import React, { useReducer, useState } from 'react';
import { connect } from 'react-redux';

import ButtonCollection from '../builder/ButtonCollection';
import Input from '../builder/Input';
import TextArea from '../builder/TextArea';
import Model from '../builder/Model';
import { CreateButton, SecondaryButton } from '../builder/ActionButton';
import FloatingLayer from '../builder/FloatingLayer';
import SectionTitle from '../builder/SectionTitle';
import Tooltip from '../builder/Tooltip';
import { getRemotedbUrl, i18nIntl, isEmpty, isNotEmpty, milesNumber } from '../../lib/ep';
import BulkFromFile from '../utils/BulkFromFile';
import { FormattedMessage, injectIntl } from 'react-intl';
import { AlertMessage } from '../builder/Message';
import Spinner from '../builder/Spinner';
import ActionLink from '../builder/ActionLink';

const AddCodeSet = (props) => {
	return <AddCodeSet_new
						{...props}/>

	return <AddCodeSet_old
						{...props}/>
	
}

const AddCodeSet_old = (props) => {
	const promotion_id = props?.promotion_id ?? false;

	const [ codeset, setCodeset ] = useState({ ...(props?.codeset ?? {}), ['add_codes']:'' });
	const [ errors, setErrors ] = useState(null);

	const validate = () => {
		let status = true;
		let _errors = {};
		if(codeset.name == '') {
			_errors.name ="This field cannot be empty";
			status = false;
		}

		if(codeset.add_codes == '') {
			_errors.add_codes =  "Add one code at least";
			status = false;
		}

		setErrors(_errors);
		return { status };
	};

	const save = (cb) => {
		let res = validate();
		if(res.status === false) {
			if(cb != undefined) cb();
			return;
		}

		let _codeset = { ...codeset };
		_codeset.promotion_id = promotion_id;
		_codeset.codes = codeset.add_codes;

		$.post(getRemotedbUrl(`/promocodes/save/${promotion_id}/`), _codeset, (response) => {
			_codeset.codes = [];
			setCodeset(_codeset);

			props.dispatch({ type:'ADDCODESET', codeset:response, id:codeset.id });

			if(cb != undefined) cb();
			if(props.backButton) props.backButton();
			if(pm != undefined) pm.attributes.codeSets.push({ CodeSet:response });
			if(props.onSave !== undefined) props.onSave(response);
		}, 'JSON');
	}

	const change = (k, v) => {
		let _codeset = { ...codeset, [k]:v };
		setCodeset(_codeset);

		if(errors != undefined) validate();
	}

	return (
		<FloatingLayer backButton={props.backButton}>
			<div>
				<SectionTitle>Code set</SectionTitle>

				<Model model={codeset} change={change} errors={errors}>
					<Input
						name="name"
					>Title</Input>

					<TextArea
						name="add_codes"
						label_props={{
							tooltip:<Tooltip>Insert the list of codes to create your codes. Write the list with one code per line. In case of using the code set to distribute to participants, the codes will be assigned in the same oder as you enter them.</Tooltip>,
						}}
					>Copy-paste a list of codes</TextArea>
				</Model>

				<ButtonCollection in_floating={true}>
					{(codeset.id) && (
						<CreateButton
							onClick={(e, cb) => save(cb)}
						>Add codes</CreateButton>
					)}

					{(codeset.id && location.hash != `#newcodesets/manage/${codeset.id}`) && (
						<SecondaryButton
							_href={`#newcodesets/manage/${codeset.id}`}
						>View codes</SecondaryButton>
					)}

					{codeset.id == undefined && (
						<CreateButton
							onClick={(e, cb) => save(cb)}
						>Create a code set</CreateButton>
					)}
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
}
const AddCodeSet_new = (props) => {

	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const promotion_id = props?.promotion_id ?? false;

	const max_batch = 100000;
	const max_total = 1000000;
	
	const [ state, dispatch ] = useReducer((state, action) => {
		switch(action.type) {
			case 'CHANGE_CODESET':

				let _errors = state.errors;
				if(_errors[action.k] != undefined)delete _errors[action.k];
				if(action.k == 'name' && isEmpty(action,'v'))_errors.name = "This field cannot be empty";
				/*
				//de moment no controlem que es puguin afegir codis sense espais en blanc
				if(k == 'add_codes'){
					let code_with_spaces = false;
					for (let i = 0; i < (_codeset?.add_codes ?? []).length; i++) {
						if (/\s/.test(_codeset.add_codes[i])) {
							code_with_spaces = _codeset.add_codes[i];
							break; 
						}
					}
					if(code_with_spaces){
						_errors.add_codes = `${i18n("Some code contain spaces")}: "${code_with_spaces}"`;
					}
				}*/
				return {
					...state,
					codeset:{
						...state.codeset,
						[action.k]:action.v,
					},
					errors:_errors
				};

			case 'ON_IMPORT':
				return {
					...state,
					errors:{},
					status:'preview',
					batch_exceeded:action.batch_exceeded,
					total_exceeded:action.total_exceeded,
				};

			case 'RESET_CODES':
				return {
					...state,
					codes:[],
					errors:{},
					batch_exceeded:null,
					total_exceeded:null,
				};

			case 'CHANGE':
				return {
					...state,
					[action.k]:action.v,
				};

			default:
				return state;
		}
	}, {
		codeset:props?.codeset ?? { name:''},
		errors:{},
		batch_exceeded:null,
		total_exceeded:null,
		status:false,
	});

	const save = (codes) => {

		const formData = new FormData();
		formData.append('codes', JSON.stringify(codes));
		formData.append('name', state.codeset.name);

		const update = (state.codeset.id != undefined) ? true : false;

		let url = `/v24/promocodes/${promotion_id}`;
		if(update) url = `${url}/${state.codeset.id}`;
		dispatch({ type:'CHANGE', k:'status',v:'upload'});
		$.ajax({
			url,
			type: 'POST',
			data: formData,
			processData: false,
			contentType: false,
			success: (response) => {
				if(response.status == 1){
					
					let _codeset = {...state.codeset};
					_codeset.id = response.set_id;
					_codeset.promotion_id = promotion_id;
					_codeset.name = state.codeset.name;
					_codeset.total_codes = (_codeset?.total_codes ?? 0) + parseInt(response.codes_inserted);
					props.dispatch({ type:'ADDCODESET', codeset:_codeset, id: update ? response.set_id : null });
					
					//if(cb != undefined) cb();
					if(props.backButton) props.backButton();
					if(pm != undefined) pm.attributes.codeSets.push({ CodeSet:{...response,..._codeset} });
					if(props.onSave !== undefined) props.onSave(response);
				}else{
					alert('ERROR, Contact us!');
				}
				dispatch({ type:'CHANGE', k:'status',v:null});
			},
			error: (xhr, status, error) => {
				console.error('Error:', error);
			}
		});
	}
	
	const reset = (window_close) =>{
		dispatch({ type:'RESET_CODES', status:!window_close ? 'preview' : null});
		if(props.backButton != undefined && window_close)props.backButton();
	}

	let title = i18n("Add codeset");
	if(state.codeset.id != undefined) title = i18n("Code set options");
	if(state.status == 'preview') title += `: ${state.codeset.name}`;

	const disabled_import = (state.batch_exceeded || state.total_exceeded || isEmpty(state.codeset,'name')) ? true : false;

	return (
		<FloatingLayer backButton={props.backButton}>
			<div>
				{(state.status == 'upload') && (
					<Spinner 
						is_transparent={false}
						force_bg={true}
						autotranslate={false}
						color="var(--ep-black-color)"
					><p>{`${i18n("Upload in progress")}...`}</p><p>{i18n("This could take a while.")}</p></Spinner>
				)}

				<SectionTitle _class={{other:'in_bottom'}}
						autotranslate={false}
					>{state.codeset.id != undefined ? `${i18n("Code set")}: ${state.codeset.name}`: `${i18n("Add codeset")}`}</SectionTitle>
				
				{(state.codeset.id == undefined) && (
					<Model model={state.codeset} change={(k,v) => dispatch({ type:'CHANGE_CODESET', k, v })} errors={state.errors} classname="in_top gui_is_padded">
						<Input
							name="name"
						>Title</Input>
					</Model>
				)}

				{(state.batch_exceeded || state.total_exceeded) ? (
					<AlertMessage
						_class={{ other:'not_in_top' }}
					>	
						{(state.batch_exceeded) && (
							<p>{props.intl.formatMessage({ id:"The file contains more than {limit} codes. Please split the file and upload in batches." }, { limit:milesNumber(max_batch)})}</p>
						)}
						{(state.total_exceeded) && (
							<p>{props.intl.formatMessage({ id:"You have reached the maximum allowed limit of {limit} codes." }, { limit:milesNumber(max_total)})}
							<br/><FormattedMessage id="To import more codes, please contact the {link}" values={{ link:<ActionLink _target="_blank" _href={`${window.web_base_url}${((window.is_spanish) ? 'contacto' : 'contact')}/`}>Easypromos sales team</ActionLink> }} />.</p>
						)}
					</AlertMessage>
				) : (
					(isNotEmpty(state.errors,'add_codes')) && (
						<AlertMessage
							title="Error"
							_class={{ other:'not_in_top' }}
						>
							<p>{errors.add_codes}</p>
						</AlertMessage>
					)
				)}
				
				<BulkFromFile
					disable_title = {true}
					display_manage_actions={true}
					disabled_import={disabled_import}
					disable_submit={disabled_import}
					max_rows_in_preview={5}
					import_label = "Add codes"
					subtitle_clipboard={`${i18n("Paste or insert your codes below, one per line.")}<br/>${i18n("Maximum: 100,000 codes per upload.")}`}
					subtitle_upload={`${i18n("Import the list of codes from a .csv or .txt file. The file must contain a single column with one code per row.")}<br/>${i18n("Maximum: 100,000 codes per upload.")} ${i18n("If you need to import more, you can repeat the process.")}`}
					type="codes"
					max={100000000000}//Posem infinit perque no retalli limits i permet controlar errors
					tooltip_confirm_position="top"
					in_floating={true}
					onSuccess={(codes) => {
						if(codes.length > 0)save(codes.map(item => item.code));
					}}
					onImportParticipants={(resume) => {
						const rows = parseInt(resume.num_rows);
						const total_exceeded = (rows + parseInt(state.codeset?.total_codes ?? 0)) > max_total ? true : false;
						const batch_exceeded = !total_exceeded ? (rows > max_batch ? true : false) : false;
						dispatch({ type:'ON_IMPORT', batch_exceeded, total_exceeded })
					}}
					close={(window_close) => {
						if(window_close == undefined)window_close = false;
						reset(window_close);
					}}
					fields={[
						{ 
							name:'code', 
							icon:'knk-promotional-code', 
							label:"Code", 
							position:1,
							tooltip:"This is the field used to identify the code."
						}
					]}
					extra_button = {(state.codeset.id && location.hash != `#newcodesets/manage/${state.codeset.id}`) ? <SecondaryButton
							_href={`#newcodesets/manage/${state.codeset.id}`}
						>View codes</SecondaryButton> : null}
				/>
			</div>
		</FloatingLayer>
	)
}

function select(state) {
	return state;
}

export default connect(select)(injectIntl(AddCodeSet));